module.exports = __webpack_public_path__ + "img/logo2.02c796d9.png";